<script lang="ts">
    import Vue from "vue";
    import Component from 'vue-class-component';

    @Component({
        props: {
            WorkspaceId: Number,
            ProjectId: Number,
            EvalModelId: Number,
            ScoringEnabled: Boolean,
            ActivePage: String
        }
    })
    export default class GoalNavigation extends Vue
    {
    }

</script>

<template>
    <div>
        <ul class="nav nav-pills">
            <li class="nav-item" :class="{'active2': ActivePage === 'criteria-hierarchy'}">
                <a class="nav-link" v-sanitizedHref="`/#/pp/criteria-hierarchy/${WorkspaceId}/${ProjectId}/${EvalModelId}`">
                    Criteria
                </a>
            </li>
            <li class="nav-item" v-if="ScoringEnabled" :class="{'active2': ActivePage === 'criteria-scales'}">
                <a class="nav-link" v-sanitizedHref="`/#/pp/criteria-scales/${WorkspaceId}/${ProjectId}/${EvalModelId}`">
                    Measurement
                </a>
            </li>
            <li class="nav-item" v-if="!ScoringEnabled" :class="{'active2': ActivePage === 'measurement'}">
                <a class="nav-link" v-sanitizedHref="`/#/pp/measurement/${WorkspaceId}/${ProjectId}/${EvalModelId}`">
                    Measurement
                </a>
            </li>
            <li class="nav-item" :class="{'active2': ActivePage === 'criteria-surveys'}">
                <a class="nav-link" v-sanitizedHref="`/#/pp/criteria-surveys/${WorkspaceId}/${ProjectId}/${EvalModelId}`">
                    Weights
                </a>
            </li>
            <li class="nav-item" v-if="ScoringEnabled" :class="{'active2': ActivePage === 'scoring-surveys'}">
                <a class="nav-link" v-sanitizedHref="`/#/pp/scoring-surveys/${WorkspaceId}/${ProjectId}/${EvalModelId}`">
                    Scoring
                </a>
            </li>
            <li class="nav-item" v-if="!ScoringEnabled" :class="{'active2': ActivePage === 'weighted-scores'}">
                <a class="nav-link" v-sanitizedHref="`/#/pp/weighted-scores/${WorkspaceId}/${ProjectId}/${EvalModelId}`">
                    Scores
                </a>
            </li>

            <li class="nav-item" :class="{'active2': ActivePage === 'results'}">
                <a class="nav-link" v-sanitizedHref="`/#/pp/results/${WorkspaceId}/${ProjectId}/${EvalModelId}`">
                    Ranking
                </a>
            </li>
        </ul>
        <hr style="border-color: #bbb; margin: 0 0 60px;" />
    </div>
</template>

<style scoped>
    .nav-pills li a {
        border-radius: 0;
        color: black;
        background-color: transparent;
    }

       .nav-pills li a:hover {
            color: gray;
        }


   .nav-pills li.active2 {
        border-bottom: 3px solid blue;
    }

        .nav-pills li.active2 a {
            color: blue;
        }

</style>